import React from 'react';
import Check from '@guildeducationinc/recess/icons/CheckIcon';
import { GetMemberProgramQuery } from 'src/graphqlTypes/catalogServiceTypes';
import { Typography, ShowMore } from '@guildeducationinc/recess';
import styles from './SkillsList.module.scss';

interface Props {
	program: GetMemberProgramQuery['memberProgram'];
}

export const SkillsList: React.FC<Props> = ({ program }) => {
	const skills = program?.contentItems.filter(item => item.category === 'SKILL');

	if (skills.length === 0) {
		return null;
	}

	const formatTitle = (title: string) => {
		if (title.charAt(title.length - 1) === ':') {
			return title.slice(0, -1);
		} else {
			return title;
		}
	};

	return (
		<section aria-label='skills'>
			<Typography className={styles.header} variant='h3'>
				Skills you&apos;ll build
			</Typography>
			<Typography className={styles.subhead} variant='body2'>
				You&apos;ll build real-world skills, including:
			</Typography>
			<ShowMore panelId='skills_list'>
				<div className={styles.list} role='list'>
					{skills.map(skill => (
						<div
							className={styles.listItem}
							data-testid='program-detail-skills'
							key={`${skill.category}-${skill.title}`}
							role='listitem'
						>
							<div className={styles.checkCircle}>
								<Check className={styles.check} size={24} />
							</div>
							{skill.title && skill.title !== ' ' ? (
								<Typography className={styles.listItemContent} variant='body1'>
									<span className='fontWeight--700'>{formatTitle(skill.title.trim())}</span>
									{skill.body && `: ${skill.body}`}
								</Typography>
							) : (
								<Typography className={styles.listItemContent} variant='body1'>
									{skill.body}
								</Typography>
							)}
						</div>
					))}
				</div>
			</ShowMore>
		</section>
	);
};
